import type { UsercentricsServiceKey } from '@/utils/usercentricsServices';

type ExternalVideoServiceKey = Extract<UsercentricsServiceKey, 'youtube' | 'vimeo'>;

type ExternalVideoSrcDetails = {
    type: ExternalVideoServiceKey;
    src: string;
};

// https://regex101.com/r/OY96XI/1
const YOUTUBE_REGEX =
    /(?:https?:)?(?:\/\/)?(?:[0-9A-Z-]+\.)?(?:youtu\.be\/|youtube(?:-nocookie)?\.com\S*?[^\w\s-])([\w-]{11})(?=[^\w-]|$)(?![?=&+%\w.-]*(?:['"][^<>]*>|<\/a>))[?=&+%\w.-]*/im;

// https://regex101.com/r/r8FYUy/1
const VIMEO_REGEX = /^https?:\/\/(?:player\.)?vimeo\.com(?:\/video)?\/(\d+).*$/im;

export const useExternalVideoSrcDetails = (src?: string | null) => {
    return computed<ExternalVideoSrcDetails | null>(() => {
        if (!src) return null;

        const youtubeResult = YOUTUBE_REGEX.exec(src);
        if (youtubeResult?.[1]) {
            return {
                type: 'youtube',
                src: `https://www.youtube.com/embed/${youtubeResult[1]}`
            };
        }

        const vimeoResult = VIMEO_REGEX.exec(src);
        if (vimeoResult?.[1]) {
            return {
                type: 'vimeo',
                src: `https://player.vimeo.com/video/${vimeoResult[1]}`
            };
        }

        return null;
    });
};
